const disabledTextFieldSx = {
  '& .MuiInputBase-input.Mui-disabled, & .MuiSelect-select.Mui-disabled': {
    WebkitTextFillColor: 'rgba(0, 0, 0, 0.5)',
  },

  '& .MuiInputBase-input::placeholder': {
    color: 'rgba(0, 0, 0, 0.5)',
    opacity: 1,
  },
};

export default disabledTextFieldSx;
